export default "__VITE_ASSET__JEO8vR1V__"